var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto"},[_c('div',{staticClass:"flex flex-col sm:flex-row items-stretch justify-center space-y-1 sm:space-y-0 sm:space-x-4"},[_c('OverviewCard',{attrs:{"icon":{name: 'meter-icon', color: 'gray-500'},"amount":{
        volume: new Intl.NumberFormat(_vm.$i18n.locale).format(_vm.total.meters),
        increase: true,
        delta: 2,
      },"label":"total_meters"}}),_c('OverviewCard',{attrs:{"icon":{name: 'volume2', color: 'blue-light'},"amount":{
        volume: new Intl.NumberFormat(_vm.$i18n.locale).format(_vm.total.volume),
        increase: true,
        delta: 120,
      },"label":"total_volume"}}),_c('OverviewCard',{attrs:{"icon":{name: 'readout', color: 'green-light'},"amount":{
        volume: new Intl.NumberFormat(_vm.$i18n.locale).format(_vm.total.readouts),
        increase: false,
        delta: 122,
      },"label":"total_readouts"}}),_c('OverviewCard',{attrs:{"icon":{name: 'error', color: 'orange-light'},"amount":{
        volume: new Intl.NumberFormat(_vm.$i18n.locale).format(_vm.total.alerts),
        increase: false,
        delta: 12,
      },"label":"total_alerts"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }